(function () {
  'use strict';
  var shades = window.RR_SHADES || [];
  var state = { shadeIdx: 1, galleryIdx: 0, qty: 1, added: false, cartOpen: false, compareX: 50, isMobile: window.innerWidth <= 640 };
  var addTimer = null;

  function clamp01(v) { return Math.min(1, Math.max(0, v)); }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function ramp(p, a, b) { return clamp01((p - a) / (b - a)); }
  function prog(el) { var r = el.getBoundingClientRect(), vh = window.innerHeight; return clamp01(-r.top / (r.height - vh)); }

  /* Data-driven renders */
  var marqueeItems = ['BUY 2 & SAVE 25%', 'SAVE 21% ON SUBTLE RADIANCE', 'FREE SHIPPING'];
  function renderMarquee() {
    var html = marqueeItems.map(function (m) { return '<span>' + m + '</span>'; }).join('');
    document.getElementById('marqueeSet1').innerHTML = html;
    document.getElementById('marqueeSet2').innerHTML = html;
  }

  /* Smooth scroll */
  function scrollToId(id) { var el = document.getElementById(id); if (el) window.scrollTo(0, el.getBoundingClientRect().top + window.scrollY - 70); }
  document.querySelectorAll('[data-scroll-to]').forEach(function (el) { el.addEventListener('click', function (e) { e.preventDefault(); scrollToId(el.getAttribute('data-scroll-to')); }); });
/* Compare slider */
var compareBox = document.getElementById('compareBox');
var compareClip = document.getElementById('compareClip');
var compareLine = document.getElementById('compareLine');
var compareHandle = document.getElementById('compareHandle');
var pillOther = document.getElementById('pillOther');
var pillRiniroy = document.getElementById('pillRiniroy');
var tagOtherLight = document.getElementById('tagOtherLight');
var tagOtherBlend = document.getElementById('tagOtherBlend');
var tagRiniMatch = document.getElementById('tagRiniMatch');
var tagRiniMelt = document.getElementById('tagRiniMelt');

function renderCompare() {
  var pct = state.compareX;
  compareClip.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
  compareLine.style.left = pct + '%';
  compareHandle.style.left = pct + '%';
  var otherOp = pct <= 4 ? 0 : 1, riniOp = pct >= 96 ? 0 : 1;
  [pillOther, tagOtherLight, tagOtherBlend].forEach(function (el) { el.style.opacity = otherOp; });
  [pillRiniroy, tagRiniMatch, tagRiniMelt].forEach(function (el) { el.style.opacity = riniOp; });
}

if (compareBox) compareBox.addEventListener('pointerdown', function (e) {
  var startX = e.clientX, startY = e.clientY;
  var dragging = false;
  var isMouse = e.pointerType === 'mouse';

  var setFromEvent = function (ev) {
    var r = compareBox.getBoundingClientRect();
    state.compareX = clamp01((ev.clientX - r.left) / r.width) * 100;
    renderCompare();
  };

  // Mouse: drag turant shuru ho, touch: thoda wait karo intent check karne ke liye
  if (isMouse) {
    dragging = true;
    setFromEvent(e);
  }

  var move = function (ev) {
    if (!dragging) {
      var dx = Math.abs(ev.clientX - startX);
      var dy = Math.abs(ev.clientY - startY);

      // Agar vertical movement zyada hai, iska matlab user scroll karna chahta hai — drag cancel
      if (dy > dx && dy > 8) {
        window.removeEventListener('pointermove', move);
        window.removeEventListener('pointerup', up);
        return;
      }
      // Agar horizontal movement clearly zyada hai, tab hi drag start karo
      if (dx > 8) {
        dragging = true;
      }
    }
    if (dragging) {
      ev.preventDefault();
      setFromEvent(ev);
    }
  };

  var up = function () {
    window.removeEventListener('pointermove', move);
    window.removeEventListener('pointerup', up);
  };

  window.addEventListener('pointermove', move, { passive: false });
  window.addEventListener('pointerup', up);
});
  /* Apply timeline click-to-jump */
  function jumpToApplyStep(n) {
    var section = document.getElementById('apply');
    var targets = { 1: 0.15, 2: 0.45, 3: 0.75 };
    var vh = window.innerHeight;
    var scrollableHeight = section.offsetHeight - vh;
    var sectionTop = section.getBoundingClientRect().top + window.scrollY;
    window.scrollTo(0, sectionTop + scrollableHeight * targets[n]);
  }
  document.querySelectorAll('.apply-node').forEach(function (btn) {
    btn.addEventListener('click', function () { jumpToApplyStep(parseInt(btn.getAttribute('data-step'), 10)); });
  });

  /* Finale cursor glow */
  var mouseX = null, mouseY = null;
  window.addEventListener('mousemove', function (e) { mouseX = e.clientX; mouseY = e.clientY; applyFinaleCursor(); });
  function applyFinaleCursor() {
    var stage = document.getElementById('finaleStage');
    if (!stage || mouseX == null) return;
    var r = stage.getBoundingClientRect();
    if (r.bottom < 0 || r.top > window.innerHeight) return;
    var nx = clamp01((mouseX - r.left) / r.width), ny = clamp01((mouseY - r.top) / r.height);
    var glow = document.getElementById('finaleGlow');
    if (glow) { glow.style.setProperty('--fx', (nx * 100).toFixed(1) + '%'); glow.style.setProperty('--fy', (ny * 100).toFixed(1) + '%'); }
    var particles = document.getElementById('finaleParticles');
    if (particles) particles.style.transform = 'translate(' + ((nx - 0.5) * 16).toFixed(1) + 'px,' + ((ny - 0.5) * 12).toFixed(1) + 'px)';
  }

  /* Scroll-driven animation */
  var raf = null;
  function onScroll() { if (!raf) raf = requestAnimationFrame(function () { raf = null; drive(); }); }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { state.isMobile = window.innerWidth <= 640; onScroll(); });

  function drive() {
    var stickyAtc = document.getElementById('stickyAtc');
    var addRow = document.querySelector('.add-row');
    var finaleSection = document.getElementById('finale');
    var atcVisible = false;
    if (stickyAtc && addRow) {
      var rowAbove = addRow.getBoundingClientRect().bottom < 0;
      var nearFooter = finaleSection ? finaleSection.getBoundingClientRect().top < window.innerHeight * 0.6 : false;
      atcVisible = rowAbove && !nearFooter;
      stickyAtc.classList.toggle('is-visible', atcVisible);
    }
    var instaFab = document.getElementById('instaFab');
    if (instaFab) instaFab.style.bottom = atcVisible ? (state.isMobile ? '140px' : '146px') : '70px';

    var finale = document.getElementById('finale');
    if (finale) {
      var fp = prog(finale);
      var lid = document.getElementById('finaleLid');
      var base = document.getElementById('finaleBase');
      var burst = document.getElementById('finaleBurst');
      var inner3d = document.getElementById('finale3d');
      var settleT = ramp(fp, 0, 0.3);
      var floatAmt = Math.sin(fp * Math.PI * 4) * 3 * (1 - settleT);
      var rotT = ramp(fp, 0.08, 0.32);
      if (inner3d) inner3d.style.transform = 'rotateY(' + lerp(-10, 0, rotT).toFixed(2) + 'deg) rotateX(' + lerp(6, 0, rotT).toFixed(2) + 'deg)';
      var naturalT = ramp(fp, 0.15, 0.75);
      var naturalEase = naturalT < 0.5 ? 2 * naturalT * naturalT : 1 - Math.pow(-2 * naturalT + 2, 2) / 2;
      var hingeAngle = lerp(108, 7, naturalEase);
      var compress = 0;
      var raw = ramp(fp, 0.75, 0.92);
      if (raw > 0) { var eased = 1 - Math.pow(1 - Math.min(raw, 1), 4); hingeAngle = lerp(7, 0, eased); }
      var snapT = ramp(fp, 0.92, 0.95);
      if (snapT > 0 && snapT < 1) compress = Math.sin(snapT * Math.PI) * -1.6;
      else if (snapT >= 1) { var t2 = ramp(fp, 0.95, 0.98); compress = Math.sin((1 - t2) * Math.PI) * -1.6 * (1 - t2) * 0.3; }
      if (lid) lid.style.transform = 'rotateX(' + (hingeAngle + floatAmt * 0.4).toFixed(2) + 'deg)';
      if (base) base.style.transform = 'translateY(' + (-floatAmt * 0.5 + compress * 0.3).toFixed(1) + 'px)';
      if (burst) {
        var b = ramp(fp, 0.9, 0.97);
        burst.style.opacity = (b < 1 ? Math.sin(b * Math.PI) * 0.55 : 0).toFixed(3);
        burst.style.transform = 'translate(-50%,-50%) scale(' + lerp(0.4, 3.5, b).toFixed(2) + ')';
      }
      var stillT = ramp(fp, 0.9, 0.94);
      var particles = document.getElementById('finaleParticles');
      if (particles) particles.style.opacity = lerp(lerp(0.55, 0.3, settleT), 0.05, stillT).toFixed(3);
      var bg = document.getElementById('finaleBg');
      if (bg) {
        var warm = ramp(fp, 0.85, 1);
        bg.style.background = 'radial-gradient(ellipse ' + lerp(70, 55, warm).toFixed(0) + '% ' + lerp(55, 45, warm).toFixed(0) + '% at 50% 42%, ' + (warm > 0.5 ? '#FCF5E9' : '#FBF4E8') + ', #EFE2D0 55%, #E4D2B6)';
      }
      var reveal = function (id, a, b2, dist) {
        var el = document.getElementById(id);
        if (!el) return;
        var o = ramp(fp, a, b2);
        el.style.opacity = o.toFixed(3);
        el.style.transform = 'translateY(' + lerp(dist, 0, o).toFixed(1) + 'px)';
      };
      reveal('finaleLine1', 0.66, 0.76, 18);
      reveal('finaleLine2', 0.8, 0.9, 18);
      reveal('finaleCta', 0.86, 0.94, 14);
      var copy = document.getElementById('finaleCopy');
      if (copy) copy.style.transform = 'translateX(-50%) translateY(' + lerp(14, -6, fp).toFixed(1) + 'px)';
      var fade = document.getElementById('finaleFootfade');
      if (fade) fade.style.opacity = ramp(fp, 0.94, 1).toFixed(3);
    }

    var apply = document.getElementById('apply');
    if (apply) {
      var ap = prog(apply);
      var heading = document.getElementById('applyHeading');
      if (heading) { var hAp = ramp(ap, 0, 0.06); heading.style.opacity = hAp.toFixed(3); heading.style.transform = 'translateY(' + lerp(16, 0, hAp).toFixed(1) + 'px)'; }
      var lineFill = document.getElementById('timelineFill');
      if (lineFill) lineFill.style.width = (ramp(ap, 0.1, 0.85) * 100).toFixed(1) + '%';
      var stepRanges = [[0.08, 0.35], [0.35, 0.62], [0.62, 0.9]];
      stepRanges.forEach(function (rg, i) {
        var n = i + 1;
        var node = document.getElementById('applyNode' + n);
        var num = document.getElementById('applyNum' + n);
        var panel = document.getElementById('applyPanel' + n);
        var activeT = ramp(ap, rg[0], rg[0] + (rg[1] - rg[0]) * 0.3);
        var fadeOutT = i < 2 ? ramp(ap, stepRanges[i + 1][0], stepRanges[i + 1][0] + (stepRanges[i + 1][1] - stepRanges[i + 1][0]) * 0.3) : 0;
        var isActive = Math.max(activeT - fadeOutT, 0);
        if (node) node.style.opacity = (0.45 + 0.55 * isActive).toFixed(3);
        if (num) {
          num.style.transform = 'scale(' + (1 + 0.1 * isActive).toFixed(3) + ')';
          num.style.background = isActive > 0.5 ? 'linear-gradient(135deg,#3B1A1A,#9A5A2E)' : 'rgba(59,26,26,.08)';
          num.style.color = isActive > 0.5 ? '#F1EEE6' : '#3B1A1A';
          num.style.borderColor = isActive > 0.5 ? 'transparent' : 'rgba(59,26,26,.15)';
        }
        if (panel) { panel.style.opacity = isActive.toFixed(3); panel.style.pointerEvents = isActive > 0.5 ? 'auto' : 'none'; panel.style.transform = 'translateY(' + lerp(10, 0, isActive).toFixed(1) + 'px)'; }
      });
      var dropT = ramp(ap, 0.08, 0.33);
      for (var d = 1; d <= 4; d++) {
        var dropEl = document.getElementById('applyDrop' + d);
        if (dropEl) { var dt = clamp01((dropT - (d - 1) * 0.12) / 0.5); dropEl.style.opacity = (1 - dt).toFixed(3); dropEl.style.transform = 'translateY(' + lerp(0, 22, dt).toFixed(1) + 'px) scale(' + lerp(1, 0.3, dt).toFixed(2) + ')'; }
      }
      var glow1 = document.getElementById('applyGlow1');
      if (glow1) glow1.style.opacity = ramp(ap, 0.15, 0.3).toFixed(3);
      var sponge = document.getElementById('applySponge');
      var sp2 = ramp(ap, 0.35, 0.45);
      if (sponge) sponge.style.transform = 'translateY(' + lerp(50, 0, sp2).toFixed(1) + 'px)';
      for (var r = 1; r <= 3; r++) {
        var rippleEl = document.getElementById('applyRipple' + r);
        if (rippleEl) { var rt = clamp01((ramp(ap, 0.42, 0.6) - (r - 1) * 0.15) / 0.4); rippleEl.style.opacity = (rt > 0 ? (1 - rt) * 0.6 : 0).toFixed(3); rippleEl.style.transform = 'scale(' + lerp(0.4, 1.6, rt).toFixed(2) + ')'; }
      }
      for (var m = 1; m <= 3; m++) {
        var markEl = document.getElementById('applyMark' + m);
        if (markEl) markEl.style.opacity = ramp(ap, 0.66 + (m - 1) * 0.05, 0.78 + (m - 1) * 0.05).toFixed(3);
      }
    }
    applyFinaleCursor();
  }

  renderMarquee();
  renderCompare();
  drive();
})();



document.addEventListener("DOMContentLoaded", function () {
  const mainSection = document.querySelector("section#mainpdp");
  const stickyAtc = document.querySelector(".sticky-atc");
  const instaFab = document.querySelector("a#instaFab");

  if (!mainSection) return;

  const observer = new IntersectionObserver((entries) => {
    const entry = entries[0];

    if (!entry.isIntersecting && entry.boundingClientRect.bottom < 0) {
      stickyAtc?.classList.add("is-visible");
      instaFab?.classList.add("is-visible");
    } else {
      stickyAtc?.classList.remove("is-visible");
      instaFab?.classList.remove("is-visible");
    }
  }, {
    threshold: 0
  });

  observer.observe(mainSection);
});